import React from 'react';

export const useSubscribeToPriceModalState = () => {
    const [ isOpenModal, toggleModal ] = React.useState(false);

    const openModal = React.useCallback(() => {
        toggleModal(true);
    }, []);

    const closeModal = React.useCallback(() => {
        toggleModal(false);
    }, []);

    return {
        isOpenSubscribeToPriceModal: isOpenModal,
        openSubscribeToPriceModal: openModal,
        closeSubscribeToPriceModal: closeModal
    };
};
